module.exports = __webpack_public_path__ + "static/media/logo-inceres.dd9a0c5a.png";